<template>
  <div id="offers-wrapper">
    <section class="offers-container container">
      <h3>{{ $t("testimonials.title") }}</h3>
      <div class="row">
        <!-- Notifications -->
        <div class="offer notifications col-3">
          <div class="offer-svg-continer">
            <inline-svg
              :src="require('@/assets/img/notification_graphic.svg')"
              width="120"
              height="100"
              fill="#202A38"
              aria-label="Facebook"
            ></inline-svg>
          </div>

          <span class="offer-title">Notifications</span>
          <span class="offer-content">Sed pretium mauris sagittis bibendum placerat nam.</span>
        </div>

        <!-- Documentations -->
        <div class="offer documentations col-3">
          <div class="offer-svg-continer">
            <inline-svg
              :src="require('@/assets/img/documentations_graphic.svg')"
              width="120"
              height="100"
              fill="#202A38"
              aria-label="Facebook"
            ></inline-svg>
          </div>

          <span class="offer-title">Documentations</span>
          <span class="offer-content">Sed pretium mauris sagittis bibendum placerat nam.</span>
        </div>

        <!-- Payment Methods -->
        <div class="offer payment col-3">
          <div class="offer-svg-continer">
            <inline-svg :src="require('@/assets/img/payment_graphic.svg')" width="120" height="110" fill="#202A38" aria-label="Facebook"></inline-svg>
          </div>
          <span class="offer-title">Payment Methods</span>
          <span class="offer-content">Sed pretium mauris sagittis bibendum placerat nam.</span>
        </div>

        <!-- Service Center Methods -->
        <div class="offer service-center col-3">
          <div class="offer-svg-continer">
            <inline-svg
              :src="require('@/assets/img/servicecenter_graphic.svg')"
              width="120"
              height="110"
              fill="#202A38"
              aria-label="Facebook"
            ></inline-svg>
          </div>

          <span class="offer-title">Service Center</span>
          <span class="offer-content">Sed pretium mauris sagittis bibendum placerat nam.</span>
        </div>
      </div>
      <div class="row offers-action">
        <div class="col-3">
          <button class="gts-secondary">See All Offers!</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
export default {
  name: "BrandOffers",
  components: {
    InlineSvg,
  },
};
</script>

<style lang="scss" scoped>
#offers-wrapper {
  margin-top: 5rem;
  .offers-container {
    h3 {
      color: #216dd9;
      font-weight: 500;
      text-align: center;
      font-size: 26px;
    }
    .row {
      margin-top: 5rem;

      .offer {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 2.5rem;

        .offer-svg-continer {
          min-height: 130px;
          display: flex;
          align-items: center;
        }

        .offer-title {
          font-size: 1.25rem;
          font-weight: 500;
          margin: 1rem 0;
        }
        .offer-content {
          text-align: center;
          font-size: 0.85rem;
          font-weight: 400;
          max-width: 200px;
          line-height: 1.3rem;
          color: #555555;
        }
      }
    }

    .offers-action {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 2.5rem;

      .col-3 {
        justify-content: flex-end;
        display: flex;
        padding: 0 2.5rem;
      }
    }
  }
}
</style>
